import React from "react";
import styles from "./AccreditationsRegulatory.module.css";
import Image from "next/image";
import parser from "html-react-parser";

interface Data {
  title: string;
  cards: itemCards[];
}

interface itemCards {
  id: number;
  title: string;
  image: {
    id: number;
    url: string;
    alternativeText: string;
  };
  description: string;
  list: cardList[];
  link: {
    id: number;
    label: string;
    url: string;
  };
}

interface cardList {
  id: number;
  item: string;
}

interface AccreditationsRegulatoryProps {
  data: Data;
}

export const AccreditationsRegulatory: React.FC<
  AccreditationsRegulatoryProps
> = ({ data }) => {
  return (
    <div className={styles.Regulatory}>
      <div className="container">
        <h3 className="text-left mb-5">{data?.title}</h3>

        <div className="row g-4">
          <div className={`col-md-6 ${styles.cardContainer}`}>
            {data?.cards?.map((item) => (
              <div key={item.id} className={`card ${styles.card}`}>
                <div className={styles.cardContent}>
                  {item?.image?.url && (
                    <Image
                      src={item?.image?.url}
                      alt={item?.image?.alternativeText}
                      title={item?.image?.alternativeText}
                      className={styles.logo}
                      width={148}
                      height={56}
                    />
                  )}
                  <div>
                    <h4>{item?.title}</h4>
                    {item?.description && (
                      <div>{parser(item?.description)}</div>
                    )}
                  </div>
                  <ul>
                    {item?.list.map((item) => (
                      <li key={item?.id}>{item?.item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          <div className={`col-md-6 ${styles.cardContainerOne}`}>
            {data?.cards?.map((item) => (
              <div key={item.id} className={`card ${styles.card}`}>
                <div className={styles.cardContent}>
                  {item?.image?.url && (
                    <Image
                      src={item?.image?.url}
                      alt={item?.image?.alternativeText}
                      title={item?.image?.alternativeText}
                      className={styles.logo}
                      width={148}
                      height={56}
                    />
                  )}
                  <div>
                    <h4>{item?.title}</h4>
                    {item?.description && (
                      <div>{parser(item?.description)}</div>
                    )}
                  </div>
                  <ul>
                    {item?.list.map((item) => (
                      <li key={item?.id}>{item?.item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
